export default function (Component) {
Component.options.__tip = "<p><code>FdAlert</code> supports <code>v-model</code>. You can use <code>v-model</code> to control the visibility of the alert.</p>\n"
}